import actions from './actions';

const initState = {
    subCategories   : {
        data: []
    },
    loading : false,
    subCategoryDeleted : false,
    message: null,
    status: null

};

export default function fetchSubCategoriesReducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_SUBCATEGORIES_REQUESTED:
            return {
                ...state,
                subCategories   : {
                    data: []
                },
                loading : true
            };
        case actions.FETCH_SUBCATEGORIES_SUCCEEDED:
            return {
                ...state,
                subCategories: {
                    ...state.subCategories,
                    data: [...action.subCategories.data],
                    [action.subCategories.parent_id]: {...action.subCategories},
                },
                loading     : false
            };
        case actions.FETCH_SUBCATEGORIES_FAILED:
            return {
                ...state,
                subCategories   : {
                    data: []
                },
                loading : false
            };
        case actions.DELETE_SUBCATEGORY_REQUESTED:
            return {
                ...state,
                subCategories   : {
                    data: []
                },
                loading : true
            };
        case actions.DELETE_SUBCATEGORY_SUCCEEDED:
            return {
                ...state,
                loading     : false,
                subCategoryDeleted : true,
                message: "SubCategory deleted successfully!",
                status: 200
            };
        case actions.DELETE_SUBCATEGORY_FAILED:
            return {
                ...state,
                subCategories   : {
                    data: []
                },
                loading : false,
                message: action?.error?.message,
                status: action?.error?.status
            };
        case actions.CLEAR_ALERT_MESSAGE:
            return {
                ...state,
                message: null,
                status: null
            };
        case actions.CLEAR_DATA:
            return {
                ...state,
                message: null,
                status: null,
                subCategories   : {
                    data: []
                },
            };
        default:
            return state;
    }
}
